import axios from './axios'


export default class CourseService{
    static async list(query={}){
        return await axios.get("/course/list",{
            params:query
        });
    }

    static async details(slug){
        return await axios.get("/course/details/"+ slug);
    }

}